import { useState } from "react";
import { toast } from "sonner";
import QRCode from "react-qr-code";
import { AnimatePresence, motion } from "framer-motion";
import { Check, Copy, Download, Share2, X } from "lucide-react";
import { EMAIL, PHONE } from "@/lib/site";

const VCARD = `BEGIN:VCARD
VERSION:3.0
FN:KischioWood — Hannes Kischio
ORG:KischioWood
TEL;TYPE=CELL:+4915120707720
EMAIL:kischio@yahoo.de
ADR:;;Neu Placht 4E;Templin;;17268;Deutschland
NOTE:Brennholz, Bauholz, Forstdienstleistungen & Holzkunst
END:VCARD`;

export const ShareFab = () => {
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const url = typeof window !== "undefined" ? window.location.origin : "";

    const share = async () => {
        const data = { title: "KischioWood", text: "Brennholz, Bauholz & Holzkunst aus der Uckermark", url };
        if (navigator.share) {
            try {
                await navigator.share(data);
            } catch (e) { /* abgebrochen */ }
        } else {
            copyLink();
        }
    };

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (e) {
            toast.error("Kopieren nicht möglich.");
        }
    };

    const saveContact = () => {
        const blob = new Blob([VCARD], { type: "text/vcard" });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "KischioWood.vcf";
        a.click();
        URL.revokeObjectURL(a.href);
        toast.success("Kontakt heruntergeladen — auf dem Handy öffnen zum Speichern.");
    };

    return (
        <div className="fixed bottom-6 left-6 z-50" data-testid="share-fab">
            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, y: 12, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 12, scale: 0.95 }}
                        transition={{ duration: 0.2 }}
                        className="mb-4 w-64 rounded border border-[#2E2517] bg-[#1B150E] p-5 shadow-[0_8px_32px_rgba(0,0,0,0.5)]"
                        data-testid="share-popover"
                    >
                        <div className="mb-4 flex items-center justify-between">
                            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C88A45]">Website teilen</p>
                            <button data-testid="share-close" onClick={() => setOpen(false)} aria-label="Schließen" className="text-[#9C917D] hover:text-[#EDE6DA]"><X size={16} /></button>
                        </div>
                        <div className="mb-4 flex justify-center rounded bg-white p-3" data-testid="share-qr">
                            <QRCode value={url} size={120} />
                        </div>
                        <div className="space-y-2">
                            <button data-testid="share-native" onClick={share} className="flex w-full items-center gap-2 rounded-full bg-[#C88A45] px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#120E09] transition-colors hover:bg-[#DBA057]">
                                <Share2 size={14} /> Teilen
                            </button>
                            <button data-testid="share-copy" onClick={copyLink} className="flex w-full items-center gap-2 rounded-full border border-[#2E2517] px-4 py-2 text-xs text-[#EDE6DA] transition-colors hover:border-[#C88A45]/50">
                                {copied ? <Check size={14} className="text-[#7A9B5A]" /> : <Copy size={14} />} {copied ? "Kopiert!" : "Link kopieren"}
                            </button>
                            <button data-testid="share-vcard" onClick={saveContact} className="flex w-full items-center gap-2 rounded-full border border-[#2E2517] px-4 py-2 text-xs text-[#EDE6DA] transition-colors hover:border-[#C88A45]/50">
                                <Download size={14} /> Kontakt speichern ({PHONE})
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
            <button
                data-testid="share-toggle"
                onClick={() => setOpen(!open)}
                aria-label="Website teilen"
                className="flex h-14 w-14 items-center justify-center rounded-full border border-[#2E2517] bg-[#1B150E] text-[#C88A45] shadow-[0_4px_16px_rgba(0,0,0,0.4)] transition-transform duration-200 hover:scale-110 active:scale-95"
            >
                <Share2 size={22} />
            </button>
        </div>
    );
};
